import React from "react";
import ReactMarkdown from "react-markdown";
import { CodeRenderer, CodeRendererWithTransparentBackground } from "./CodeRenderer";
import "./markdown.scss";

let Markdown = (props) => {
  const { children: text, transparent } = props;

  let InlineCode = ({ value, children, nodeKey}) => {
    return (
      <span className="inline-code" key={nodeKey}>
        {children}
      </span>
    )
  };
  let RegularText = ({ value, children, nodeKey}) => {
    return (
      <span className="regular-text" key={nodeKey}>
        {children}
      </span>
    )
  };

  return (
    <ReactMarkdown linkTarget="_blank"
      className={`markdown-container${transparent ? " transparent" : ""}`}
      parserOptions={{commonmark: true}}
      renderers={{
        inlineCode: InlineCode,
        text: RegularText,
        code: transparent ?
                CodeRendererWithTransparentBackground : CodeRenderer,
      }}
    >
      {text}
    </ReactMarkdown>
  );
};

export { Markdown };
